'use client';

import { useProductPriceData } from 'app/[lang]/[esite]/(core)/(search-display)/hooks/useProductPriceData';
import { ProductCardTitleProps } from 'components/product-comparison-grid/product-comparison-card/product-card-title';
import ProductCardThumbnail from 'components/product-comparison-grid/product-comparison-card/product-card-thumbnail';
import { PAGE_SIZE } from 'app/[lang]/[esite]/(core)/category/[category]/constants';

interface ThumbnailWrapperProps {
  imgSrc: string;
  width?: number;
  height?: number;
  products: Product[];
  serialNumber: string;
  index: number;
  ecommerceListNameAndId: string;
  cartId?: string;
  page?: number;
}

const ThumbnailWrapper = (
  props: ThumbnailWrapperProps & ProductCardTitleProps
) => {
  const {
    productNumber,
    index,
    products,
    serialNumber,
    page,
    ecommerceListNameAndId
  } = props;
  const indexPage = PAGE_SIZE * (page - 1);
  const productIndex = indexPage + index;
  const { productPriceData, fitmentCheck } = useProductPriceData({
    productNumber,
    index: productIndex + 1,
    products,
    serialNumber,
    ecommerceListNameAndId
  });

  return (
    <ProductCardThumbnail
      {...props}
      productPriceData={productPriceData}
      fitmentCheck={fitmentCheck}
    />
  );
};

export default ThumbnailWrapper;
